import { createSelector } from '@ngrx/store'

export const getSystemSettingsState = createSelector(
  (state: any) => state.systemSettings,
  (state: any) => state,
)
